import { getRequest } from "./lookApi/request";

export const getDecisionChoosenApi = async () => {
  return await getRequest("/recommend/getDecisionChoosen");
};

export const getChangeProChoosenApi = async () => {
  return await getRequest("/proChoose/getChangeProChoosen");
};

export const getAdviceChoosenApi = async () => {
  return await getRequest("/recommend/getAdviceChoosen");
};
